import * as z from 'zod';
export const Status = z.enum(['active', 'inactive']);
export const Address = z.object({
    country: z.string(),
    region: z.string(),
    city: z.string(),
    postalCode: z.string(),
    addressLine: z.string(),
    additionalInfo: z.string().optional(),
});
export const ConsumablesBatchesSchema = z.object({
    batches: z.array(z.object({
        batchId: z.string(),
        consumableId: z.string(),
        quantity: z.number(),
        sharedWith: z.array(z.string()),
    })),
});
export const ExtrasBatchesSchema = z.object({
    batches: z.array(z.object({
        batchId: z.string(),
        quantity: z.number(),
        sharedWith: z.array(z.string()),
        /** Drug amount the other orders sharing this vial draw from it. */
        sharedDose: z.number().optional(),
    })),
});
export const RestVialItemSchema = z.object({
    restVialId: z.string(),
    tradeNameId: z.string(),
    tradeNameName: z.string(),
    strengthUnit: z.string().nullable(),
    amount: z.number().nullable(),
    expiryDate: z.string(),
    batchId: z.string().nullable(),
});
export const ReturnItemSchema = z.object({
    returnId: z.string(),
    sequenceId: z.string().nullable(),
    carrierId: z.string().nullable(),
    medicationName: z.string().nullable(),
    medicationForm: z.string().nullable(),
    orderNumber: z.string().nullable(),
    expiryDate: z.string().nullable(),
    returnedAt: z.string().nullable(),
    reason: z.string().nullable(),
    note: z.string().nullable(),
    stockLocationName: z.string().nullable(),
    /** The substance and amount the return already provides, so only the missing dose is drawn. */
    prescribedNameId: z.string().nullable().optional(),
    providedAmount: z.number().nullable().optional(),
});
export const ListItemSchema = z.object({
    sequenceId: z.string(),
    orderId: z.string(),
    activeSubstances: ExtrasBatchesSchema,
    carrier: ExtrasBatchesSchema,
    solvents: ExtrasBatchesSchema,
    consumables: ConsumablesBatchesSchema,
    restVials: z.array(RestVialItemSchema),
    returns: z.array(ReturnItemSchema),
    isValid: z.boolean().optional(),
});
export const DistributedBatchesListResponseSchema = z.object({
    orders: z.array(ListItemSchema),
    allUsedBatchIds: z.array(z.string()),
});
//# sourceMappingURL=schemas.js.map